/**
 * Strips all HTML tags from a string.
 * Used for previews and SEO descriptions.
 */
export function stripHtml(html: string | null | undefined): string {
    if (!html) return "";
    return html.replace(/<[^>]*>?/gm, "").trim();
}

/**
 * Truncates a string to a certain length and adds an ellipsis.
 */
export function truncate(text: string, length: number): string {
    if (text.length <= length) return text;
    return text.substring(0, length) + "...";
}
